module.exports = __webpack_public_path__ + "img/128.a67a319d.jpg";